import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScLinkField } from '@core/jss-models';
import type { EcmpAffiliateLogo } from '@core/navigation-store';

@Component({
  selector: 'wl-minimal-header',
  template: '',
  standalone: true,
})
export class MinimalHeaderComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showHelp?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() brandLogoLink?: ScLinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ecmpHeader?: EcmpAffiliateLogo;
  @Output() helpRequested = new EventEmitter();
  @Output() logoClicked = new EventEmitter();

  onLogoClicked() {
    this.logoClicked.emit();
  }

  requestHelp() {
    this.helpRequested.emit();
  }
}
